/**
 * API Configuration
 * Centralizes all API and media URL settings
 */

// Determine which domain/port to use for API requests
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

// Media URL can be different from API in some setups
const MEDIA_BASE_URL = process.env.VUE_APP_MEDIA_URL || 'http://localhost:8000';

const apiConfig = {
  // Base URLs
  apiBaseUrl: API_BASE_URL,
  mediaBaseUrl: MEDIA_BASE_URL,
  
  // API endpoints - define them without API_BASE_URL to avoid double prefixing
  endpoints: {
    // Media endpoints
    media: {
      details: (hash) => `/api/media/detail/${hash}/`,
      placeholder: (width, height) => `/api/media/placeholder/${width}/${height}/`,
      test: `/api/media/test/`,
    },
    // Companies endpoints
    companies: {
      list: `/api/companies/`,
      detail: (id) => `/api/companies/${id}/`,
    },
  },
  
  // Utility function to convert relative media paths to full URLs
  getMediaUrl: (path) => {
    // Ensure we don't double-prefix with /media
    if (path.startsWith('/media/')) {
      return path;
    } else if (path.startsWith('/')) {
      return `/media${path}`;
    } else {
      return `/media/${path}`;
    }
  }
};

export default apiConfig; 